import React, { useEffect } from 'react';

const WinScreen = ({ onBackToHome }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onBackToHome();
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [onBackToHome]);

  return (
    <div className="win-screen">
      <h1>You Win!</h1>
      <button onClick={onBackToHome}>Back to Home</button>
    </div>
  );
};

export default WinScreen;
